import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { FileTypes } from 'common/dropdownOptions';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function FileTypeFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows, isContentSearchActive, isCaseFileManager, isLeadFileManager } =
    useFileManagerContext();

  const shouldDisable = isContentSearchActive && (isCaseFileManager || isLeadFileManager);

  return (
    <Dropdown
      options={FileTypes}
      value={fileManagerFilters.fileType}
      placeholder="By File Type"
      className="file-manager-select w-100"
      onChange={(e) => {
        onFilterChange(e);
        setSelectedRows([]);
      }}
      name="fileType"
      disabled={shouldDisable}
    />
  );
}

export default FileTypeFilter;
